import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Table, InputGroup, Spinner, Modal } from "react-bootstrap";
import "./_DiaryModal.scss"
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { components } from 'react-select'
import { withApollo } from "react-apollo";
import moment from "moment";



const ADD_DIARY_ASSIGNMENT_DETAILS = gql`
mutation($params:AddDairyAssignmentDetails){
    addDairyAssignmentDetails(params:$params)
}
`;


class DiaryModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            branch_id: "",
            branchError: "",
            class_id: "",
            classError: "",
            exam_id: "",
            examError: "",
            section_id: "",
            sectionError: "",
            toDate: new Date().toISOString().slice(0, 10),
            currentDate: new Date().toISOString().slice(0, 10),
            toDateError: "",
            loadingSpinner: 0,
            currentStep: 1,
            subject_id: "",
            subjectError: "",
            getExams: [],
            getClasses: [],
            getSections: [],
            getSubjects: [],
            defaultvalue: 0,
            ldescription: "",
            ldescription_error: "",
            loader: 0,
            dataClear: 0,
            submitError: "",
            submitted: false,
            file_upload: "",
            file_uploadError: "",
            isDisabled: false,
            dairyAssigment_id: null
        }
    }



    componentDidUpdate() {

        console.log("update");
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                branchError: "",
                classError: "",
                examError: "",
                sectionError: "",
                subjectError: "",
                defaultvalue: 0,
                ldescription_error: "",
                currentStep: 1,
                loadingSpinner: 0,
                dataClear: 1,
                submitError: "",
                submitted: false,
                file_upload: "",
                file_uploadError: "",
                toDateError: "",
            })

            if (this.props.stateData.existingDairyOrNoticeData.length > 0) {
                let existingData = this.props.stateData.existingDairyOrNoticeData;
                console.log("existingData", existingData);
                const branchDetails = this.props.stateData.branchSearch
                this.setState({
                    branch_id: branchDetails,
                    class_id: existingData[0].class_id,
                    section_id: existingData[0].section_ids,
                    exam_id: existingData[0].exam_id,
                    ldescription: existingData[0].description,
                    subject_id: existingData[0].subject_id,
                    toDate: moment.unix(existingData[0].from_date).format("YYYY-MM-DD"),
                    currentDate: moment.unix(existingData[0].from_date).format("YYYY-MM-DD"),
                    getExams: this.getExams(branchDetails),
                    getClasses: this.getClasses(branchDetails, existingData[0].exam_id),
                    getSections: this.getSections(branchDetails, existingData[0].exam_id, existingData[0].class_id),
                    getSubjects: this.getSubjects(existingData[0].exam_id),
                    isDisabled: true,
                    dairyAssigment_id: existingData[0].dairyAssigment_id

                })


            } else {
                this.setState({
                    branch_id: "",
                    class_id: "",
                    section_id: "",
                    ldescription: "",
                    subject_id: "",
                    exam_id: "",
                    toDate: new Date().toISOString().slice(0, 10),
                    currentDate: new Date().toISOString().slice(0, 10),
                    getExams: [],
                    getClasses: [],
                    getSections: [],
                    getSubjects: [],
                    isDisabled: false

                })
            }
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }

    }


    getExams = (branch_id) => {
        let getArray = [];

        let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branch_id).map((item1) => item1.exam_id))].sort();

        uniqueExams.map((val) => {
            let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
            const newObj = {
                value: individualExamData.id,
                label: individualExamData.exam
            }
            getArray.push(newObj);
        })
        return getArray
    }

    getClasses = (branch_id, exam_id) => {

        let getArray = [];

        let uniqueClasses = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branch_id && item.exam_id == exam_id).map((item1) => item1.class_id))].sort();

        uniqueClasses.map((val) => {
            let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
            const newObj = {
                value: individualClassData.id,
                label: individualClassData.class
            }
            getArray.push(newObj);
        })
        return getArray
    }

    getSections = (branch_id, exam_id, class_id) => {

        let getArray = [];

        let uniqueSections = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branch_id && item.exam_id == exam_id && item.class_id == class_id).map((item1) => item1.section_id))].sort();

        uniqueSections.map((val) => {
            let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
            const newObj = {
                value: individualSectionData.id,
                label: individualSectionData.section_name
            }
            getArray.push(newObj);
        })

        return getArray
    }

    getSubjects = (exam_id) => {


        let examWiseSubjects = [];

        if (this.props.globals.offlineExamSubjects.length > 0) {
            this.props.globals.exams.filter((item) => item.id == exam_id)[0].exam_subjects.map((item1) => {
                this.props.globals.offlineExamSubjects.map((item2) => {
                    if (item1.subject_id == item2.id) {
                        const newObj = {
                            value: item2.id,
                            label: item2.subject
                        }
                        examWiseSubjects.push(newObj);

                    }
                })
            })
        }

        // ===============================================================================
        const newObj = {
            value: 0,
            label: "Others"
        }
        examWiseSubjects.push(newObj);
        return examWiseSubjects;
    }


    handleInputChange = e => {

        const name = e.target.name;
        const value = e.target.value;

        let getArray = [];

        if (name == "branch") {

            if (value != "0") {
                this.setState({
                    class_id: "",
                    exam_id: "",
                    section_id: "",
                    branch_id: value,
                    branchError: "",
                    getExams: this.getExams(value),
                    getClasses: [],
                    getSections: [],
                    examError: "",
                    classError: "",
                    sectionError: "",
                    getSubjects: [],
                })
            } else {
                this.setState({
                    class_id: "",
                    exam_id: "",
                    section_id: "",
                    branch_id: "",
                    branchError: "",
                    getExams: [],
                    getClasses: [],
                    getSections: [],
                    examError: "",
                    classError: "",
                    sectionError: "",
                    getSubjects: [],
                })
            }
        }
        if (name == "class") {

            if (value != "0") {



                this.setState({
                    class_id: value,
                    section_id: "",
                    branchError: "",
                    getSections: this.getSections(this.state.branch_id, this.state.exam_id, value),
                    examError: "",
                    classError: "",
                    sectionError: "",
                    getSubjects: [],
                })

            } else {

                this.setState({
                    class_id: "",
                    section_id: "",
                    branchError: "",
                    getSections: [],
                    examError: "",
                    classError: "",
                    sectionError: "",
                    getSubjects: [],
                })

            }
        }

        if (name == "exam") {

            if (value != "0") {

                this.setState({
                    class_id: "",
                    exam_id: value,
                    section_id: "",
                    branchError: "",
                    getClasses: this.getClasses(this.state.branch_id, value),
                    getSections: [],
                    examError: "",
                    classError: "",
                    sectionError: "",
                    getSubjects: [],

                })
            } else {
                this.setState({
                    class_id: "",
                    exam_id: "",
                    section_id: "",
                    branchError: "",
                    getClasses: [],
                    getSections: [],
                    examError: "",
                    classError: "",
                    sectionError: "",
                    getSubjects: [],
                })

            }
        }

        if (name == "subject") {
            if (value != "0") {
                this.setState({ subject_id: value, subjectError: "" })
            }
        }

        if (name == "section") {

            if (value != "0") {
                this.setState({
                    section_id: value, sectionError: "", getSubjects: this.getSubjects(this.state.exam_id), subjectError: ""
                })

            } else {

                this.setState({
                    section_id: "",
                    sectionError: "",
                })
            }

        }

    };

    selecthandleInputChange = (e) => {
        let name = e.target.name
        let value = e.target.value


        if (name == "ldescription") {
            this.setState({
                ldescription_error: "",
            })
        }

        if (name == "file_upload") {
            this.setState({
                file_uploadError: "",
            })
        }

        this.setState({ [name]: value });
    }


    handleFormSubmit = () => {

        if (this.state.branch_id === "" || this.state.branch_id === "--Select Branch--") {
            this.setState({ branchError: " Please select branch " });
            return ""
        }

        if (this.state.exam_id === "" || this.state.exam_id === "--Select Exam--") {
            this.setState({ examError: "  Please Select exam " });
            return ""
        }

        if (this.state.class_id === "" || this.state.class_id === "--Select Class--") {
            this.setState({ classError: " Please select class " });
            return ""
        }

        if (this.state.section_id === "" || this.state.section_id === "--Select Section--") {
            this.setState({ sectionError: " Please select section " });
            return ""
        }

        if (this.state.subject === "" || this.state.subject === "--Select Subject--") {
            this.setState({ subjectError: " Please select Subject " });
            return ""
        }

        if (this.state.ldescription == "") {
            this.setState({ ldescription_error: "  Please Enter  Description " })
            return ""
        }

        const params = {
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: parseInt(this.state.branch_id),
            class_id: (this.state.class_id).toString(),
            section_ids: this.state.section_id,
            exam_id: (this.state.exam_id).toString(),
            from_date: moment(this.state.toDate, 'YYYY-MM-DD').unix().toString(),
            description: this.state.ldescription,
            dairy_assignment_type_id: parseInt(1),
            inserted_by: parseInt(Cookies.get("id")),
            subject_id: parseInt(this.state.subject_id),
            dairy_assignment_id: parseInt(this.state.dairyAssigment_id)
        }

        this.setState({ loadingSpinner: 1 })
        console.log("params", params);

        this.addDairyAssignmentDetails(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message), loadingSpinner: 0 });
            setTimeout(() => {
                this.props.onHide();
                window.location.reload(false);
            }, 1500);
        })
    };
    addDairyAssignmentDetails = async params => {
        await this.props.addDairyAssignmentDetails({
            variables: {
                params
            },
            update: (store, { data }) => {
                console.log("dataaaaaaaaaaaaaa", data);
                if (data.addDairyAssignmentDetails) {
                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1500);
                }

            }
        })
    }
    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();
    };

    selDate = (e) => {
        this.setState({ toDate: e.target.value })
    }

    render() {
        console.log("diary", this.state);
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title> Diary</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">
                    <Row >
                        <Col sm={12}>
                            <div className='d-flex justify-content-end my-2 mr-1'>
                                <div>
                                    <input type="date" className="form-control" name='toDate' value={this.state.toDate} disabled={this.state.isDisabled} onChange={this.selDate} style={{ borderRadius: "15px" }} />
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="mt-3">
                            <Form>
                                <Form.Row>

                                    {/* BRANCH */}
                                    <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectBranch">
                                         <h6>Branch <span className="f-16 validation_color  text-danger">{this.state.branchError}</span></h6>
                                        <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch_id} isInvalid={this.state.branchError} disabled={this.state.isDisabled}>
                                            <option >--Select Branch--</option>
                                            {this.props.globals.globalBranches.map(branchdata => (
                                                <option key={branchdata.id} value={branchdata.id} selected={this.state.branch_id == branchdata.id ? true : false}  >
                                                    {branchdata.branch_name}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>

                                    {/* EXAM */}
                                    <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectExam">
                                        <h6>Exam<span className="text-danger f-16">{this.state.examError}</span></h6>
                                        <Form.Control as="select" name="exam" onChange={this.handleInputChange} value={this.state.exam_id} isInvalid={this.state.examError} disabled={this.state.isDisabled}>
                                            <option>--Select Exam--</option>
                                            {this.state.getExams.map(item => (
                                                <option key={item.value} value={item.value} selected={this.state.exam_id == item.value ? true : false} >
                                                    {item.label}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>



                                    {/* CLASS */}
                                    <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectClass">
                                         <h6 >Class <span className="text-danger f-16">{this.state.classError}</span></h6>
                                        <Form.Control as="select" name="class" onChange={this.handleInputChange} value={this.state.class_id} isInvalid={this.state.classError} disabled={this.state.isDisabled}>
                                            <option>--Select Class--</option>
                                            {this.state.getClasses.map(classdata => (
                                                <option key={classdata.value} value={classdata.value} selected={this.state.class_id == classdata.value ? true : false}  >
                                                    {classdata.label}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>



                                    {/* SECTION */}
                                    <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectSection">
                                         <h6 >Section<span className="text-danger f-16">{this.state.sectionError}</span></h6>
                                        <Form.Control as="select" name="section" onChange={this.handleInputChange} value={this.state.section_id} isInvalid={this.state.sectionError} disabled={this.state.isDisabled}>
                                            <option >--Select Section--</option>
                                            {this.state.getSections.map(sectiondata => (
                                                <option key={sectiondata.value} value={sectiondata.value} selected={this.state.section_id == sectiondata.value ? true : false}  >
                                                    {sectiondata.label}
                                                </option>
                                            ))}
                                        </Form.Control>
                                       


                                        {/* SUBJECTS */}
                                    </Form.Group>
                                    <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectTitle">
                                         <h6>Subject<span className="text-danger f-16">{this.state.subjectError}</span></h6>
                                        <Form.Control as="select" name="subject" onChange={this.handleInputChange} value={this.state.subject} isInvalid={this.state.subjectError} disabled={this.state.isDisabled} >
                                            <option>--Select Subject--</option>
                                            {this.state.getSubjects.map(subject => (
                                                <option key={subject.value} value={subject.value} selected={this.state.subject_id == subject.value ? true : false} >
                                                    {subject.label}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                            <section>

                                <Row className='mt-4'>
                                    <Col as={Col} lg={9} md={12} sm={12}>
                                        <h6>Description<span className="text-danger f-16">{this.state.ldescription_error}</span></h6>
                                        <textarea className='description_diary_area' name="ldescription" onChange={this.selecthandleInputChange} value={this.state.ldescription}></textarea>
                                    </Col>

                                    <Col as={Col} lg={3} md={12} sm={12} className="text-center">
                                        <button className='Diary_buutton mr-4 text-uppercase' onClick={this.handleFormSubmit}>
                                            {
                                                this.state.loadingSpinner == 1 ? (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                ) : ""
                                            }Submit</button>
                                        <div className='d-block'>
                                            {this.state.currentStep == 5 ? (
                                                <Form.Text className="form-text text-Success mb-2 " style={{ textAlign: "center" }}>
                                                    <p style={{ color: "green" }}>successfully Submitted</p>
                                                </Form.Text>
                                            ) : (
                                                <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center", display: "none" }}>
                                                    {this.state.submitError}
                                                </Form.Text>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </section>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        )
    }
}


export default withRouter(compose(
    graphql(ADD_DIARY_ASSIGNMENT_DETAILS, {
        name: "addDairyAssignmentDetails"
    })
)(DiaryModal));